

















































































import { faCheck, faTag } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope as farEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope'
import { faFacebookF as fabFacebookF } from '@fortawesome/free-brands-svg-icons'
import { mapGetters, mapState } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import ExternalLink from '~/components/car/classifieds/view/partials/ExternalLink.vue'
import CExpandableContent from '~/components/shared/configurable/expand/CExpandableContent.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import CCardHeader from '~/components/shared/configurable/card/CCardHeader.vue'
import CCardTitle from '~/components/shared/configurable/card/CCardTitle.vue'
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { Description } from '~/models/classified/description/types'
import DescriptionContent from '~/components/car/classifieds/view/partials/DescriptionContent.vue'
import { I18nLocale } from '~/models/shared/types'
import BlacklistedSellerAlert from '~/components/car/classifieds/view/BlacklistedSellerAlert.vue'

export default defineComponent({
  components: {
    BlacklistedSellerAlert,
    CCardHeader,
    CExpandableContent,
    CCard,
    CCardTitle,
    ExternalLink,
    DescriptionContent
  },
  props: {
    hideTitle: {
      type: Boolean,
      default: false
    },
    description: {
      type: Object as PropType<Description>,
      required: false,
      default: undefined
    },
    classified: { type: Object, required: true },
    tags: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    disableReadmore: {
      type: Boolean,
      required: false,
      default: false
    },
    embedVideo: {
      type: Boolean,
      required: false,
      default: false
    },
    inTrades: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      translationLoaded: false
    }
  },
  computed: {
    ...mapState(CLASSIFIED_VIEW_NS, {
      rentalInsurance: state => state.classified.rentalInsurance
    }),
    basicInsuranceOptions() {
      return this.rentalInsurance?.baseInsurancePackage || []
    },
    icons() {
      return {
        tag: faTag,
        rEnvelope: farEnvelope,
        bFacebookF: fabFacebookF,
        check: faCheck
      }
    },
    ...mapGetters(USER_NS, {
      userIsAdmin: 'isAdmin'
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      isPlotClassified: 'isPlotClassified',
      sellerIsOfTypeDealer: 'sellerIsOfTypeDealer',
      isJobsClassified: 'isJobsClassified',
      isRentalClassified: 'isRentalClassified',
      descriptionContent: 'getDescriptionContent',
      descriptionLanguage: 'getDescriptionLanguage',
      sellerIsBlacklistedSuspiciousOrFraudster:
        'sellerIsBlacklistedSuspiciousOrFraudster'
    }),
    descriptionLanguageToUse() {
      return (
        this.description?.language || this.descriptionLanguage || I18nLocale.EL
      )
    },
    showGoogleTranslateButton() {
      return this.$i18n.locale !== this.descriptionLanguageToUse
    },
    descriptionToShow() {
      if (this.description?.content) {
        return this.description.content
      }
      return this.descriptionContent
    },
    isEvil() {
      if (
        !this.descriptionToShow ||
        this.sellerIsOfTypeDealer ||
        this.descriptionToShow.includes('plot.gr') ||
        this.descriptionToShow.includes('car.gr')
      ) {
        return false
      }

      const evilStrings = ['www', 'http', '@', '.com', 'hotmail', 'gmail']

      if (this.isPlotClassified) {
        evilStrings.push('e-mail', 'email')
      }
      return evilStrings.some(evilText =>
        this.descriptionToShow.toLowerCase().includes(evilText)
      )
    },
    shouldShowDescription() {
      return this.userIsAdmin || !this.isEvil
    },
    youtubeId() {
      if (this.classified.videos.length) {
        return this.classified.videos[0].url
      }

      return ''
    },
    youtubeEmbedLink() {
      if (this.youtubeId) {
        return 'https://www.youtube.com/embed/' + this.youtubeId
      }

      return null
    }
  },
  beforeDestroy() {
    if (window.googleTranslateElementInit) {
      window.googleTranslateElementInit = null
    }
  },
  methods: {
    loadTranslate() {
      window.googleTranslateElementInit = () => {
        // eslint-disable-next-line no-undef,no-new
        new google.translate.TranslateElement(
          {
            pageLanguage: this.$i18n.locale,
            includedLanguages:
              'ar,bg,cs,da,de,fi,el,en,es,fr,hu,it,nb,nl,pl,pt,ro,ru,sq,sr,sv,tr,zh',
            // eslint-disable-next-line no-undef
            layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false,
            multilanguagePage: true
          },
          'google_translate_element'
        )
        this.translationLoaded = true
      }
      const gtScript = document.createElement('script')
      gtScript.type = 'text/javascript'
      gtScript.async = true
      gtScript.src =
        'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
      ;(
        document.getElementsByTagName('head')[0] ||
        document.getElementsByTagName('body')[0]
      ).appendChild(gtScript)
    }
  }
})
